import useIntroduction, { UseIntroduction } from './vm';
import CopyToLectureIntroductionLayout from '../../../../../../shared/CopyToLectureIntroductionLayout';
import TileIntroductionForm, {
  TileIntroductionFormProps,
} from '../../../../../../shared/TileIntroductionForm';
import { Stack } from '@mui/material';
import Typography from '../../../../../../../components/Typography';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../../../../../../i18n';

export interface IntroductionProps
  extends Pick<TileIntroductionFormProps, 'className' | 'onNext'>,
    UseIntroduction {}

const Introduction = ({ className, onNext, ...vmProps }: IntroductionProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { isPollPublished } = useIntroduction(vmProps);

  return (
    <TileIntroductionForm className={className} onNext={onNext}>
      <CopyToLectureIntroductionLayout
        message={
          <Stack gap={2}>
            <Typography variant="h6Medium" component="p" textAlign="center">
              {t(
                'if_you_want_to_reuse_this_poll_in_another_course_or_lecture_you_can_easily_create_a_copy_of_it_it_allows_reusing_the_same_presentation_in_multiple_courses_and_lectures_without_having_to_recreate_the_poll',
                { ns: i18nNS.POLL }
              )}
            </Typography>
            {isPollPublished && (
              <Typography variant="h6Medium" component="p" textAlign="center">
                {t(
                  'results_of_the_conducted_poll_remain_accessible_through_acadly_and_the_new_copy_could_be_run_during_the_presentation',
                  { ns: i18nNS.POLL }
                )}
              </Typography>
            )}
          </Stack>
        }
      />
    </TileIntroductionForm>
  );
};

export default Introduction;
